import { KLARNA_PAYMENT_OPTIONS } from './utils'

const KlarnaWidgets = ({ selectedPaymentOption }) => {
  return (
    <>
      <div
        id='klarna-payments-container-pay_now'
        style={{
          display: selectedPaymentOption === KLARNA_PAYMENT_OPTIONS.PAY_NOW ? 'block' : 'none'
        }}
      />
      <div
        id='klarna-payments-container-pay_later'
        style={{
          display: selectedPaymentOption === KLARNA_PAYMENT_OPTIONS.PAY_LATER ? 'block' : 'none'
        }}
      />
      <div
        id='klarna-payments-container-pay_over_time'
        style={{
          display: selectedPaymentOption === KLARNA_PAYMENT_OPTIONS.PAY_OVER_TIME ? 'block' : 'none'
        }}
      />
    </>
  )
}

export default KlarnaWidgets
